import styled from "styled-components";

export const CellContainer = styled.div`
    overflow: hidden;
    text-overflow: ellipsis;
`;
